$(document).ready(function () {

  $('.services__items__wrapper.slider').slick({
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    swipe: false,
    fade: true,
  });

  /*
  $('.services__items').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: "<span class='prev-arrow'></span>",
    nextArrow: "<span class='next-arrow'></span>",
  });
   */

  $('.services_menu li').click(function(e){
    e.preventDefault();
    $('.services__items__wrapper.slider').slick('slickGoTo', $(this).index());
    $('.services_menu li.active').removeClass('active');
    $(this).addClass('active');
  });

  $('.services_menu li').first().click();

  $('.services__content.level-1 .service').click(function(){
    $('.services__content.level-1').slideUp();
    $('.services__content.level-2').slideDown();
  });

  $('.services__content.level-2 .back-button').click(function(){
    $('.services__content.level-1').slideDown();
    $('.services__content.level-2').slideUp();
  });
});
